import { render } from "./AppSvgEnergi.vue?vue&type=template&id=0c189137&scoped=true"
import script from "./AppSvgEnergi.vue?vue&type=script&lang=js"
export * from "./AppSvgEnergi.vue?vue&type=script&lang=js"

import "./AppSvgEnergi.vue?vue&type=style&index=0&id=0c189137&lang=scss&scoped=true"

import exportComponent from "/Users/patriksvensson/Documents/Projects/KK/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c189137"]])

export default __exports__